import React, {useState, useEffect} from "react";

const WhisperChattingInfo = ({ stdInfo }) => {
    const [userInfo, setUserInfo] = useState(stdInfo);

    useEffect(() => {
        setUserInfo(stdInfo);
    }, [stdInfo]);

    return (
        <div className="title-area main hiclasstv-blue">
            <div className="text-area justify-content-start">
                <span className="hiclass-text white-text" title={userInfo.stdNickname}>
                    {userInfo.stdNickname}
                </span>
            </div>
        </div>
    );
}

export default WhisperChattingInfo;